import HelpManual from "@/pages/admin/help/Index.vue";
import { isAdminViewer } from "@/help/manifest";

/**
 * In-app User Manual routes.
 *
 * These are children of /app (the plain Main layout), NOT of /app/admin — the
 * manual is a self-contained full-page shell with its own sidebar, search and
 * top bar, so it must not inherit the admin navigation drawer / app bar.
 * The URLs stay under /app/admin/help so existing links and the app-bar entry
 * keep working, and the route names stay `app-admin-*` so the app's
 * `hasRouteAccess` check treats them as admin routes.
 *
 * Admin portal only for now. Customer / vendor manuals will be added later as
 * separate audiences. The guard sends any non-admin viewer to login rather than
 * revealing that the manual exists.
 */
function adminOnly(to, from, next) {
  if (isAdminViewer()) {
    next();
  } else {
    next({ path: "/app/login" });
  }
}

const helpRoutes = [
  {
    path: "admin/help",
    name: "app-admin-help",
    component: HelpManual,
    beforeEnter: adminOnly,
  },
  {
    path: "admin/help/:domain/:slug",
    name: "app-admin-help-article",
    component: HelpManual,
    beforeEnter: adminOnly,
  },
];

export default helpRoutes;
